import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from './action-sheet';
import { VerificationMethod } from '@/enums';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSelect: (verificationMethod: VerificationMethod) => void;
  phoneNumber: string;
}

export const SignInMethodActionSheet: React.FC<Props> = ({
  isVisible,
  onClose,
  onSelect,
  phoneNumber,
}) => {
  const resendVerificationOptions: {
    displayString: string;
    method: VerificationMethod;
  }[] = [
    {
      displayString: i18n.t('verification_resend_text', {
        phoneNumber,
      }),
      method: VerificationMethod.SMS,
    },
    {
      displayString: i18n.t('verification_resend_call', {
        phoneNumber,
      }),
      method: VerificationMethod.Call,
    },
  ];

  return (
    <ActionSheet
      actions={resendVerificationOptions.map((x) => x.displayString)}
      isVisible={isVisible}
      onAction={(_, index) => {
        onSelect(resendVerificationOptions[index].method);
        onClose();
      }}
      onClose={onClose}
      primaryIndices={resendVerificationOptions.map((_, i) => i)}
      title={i18n.t('verification_method_message')}
    />
  );
};
